module.exports = __webpack_public_path__ + "img/noActive.11595776.png";